import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getPlanCounterpartyMismatch } from '@ebalance/proto/bffuser/v1/submission_management_service-SubmissionManagementService_connectquery'
import type { GetPlanCounterpartyMismatchResponse } from '@ebalance/proto/bffuser/v1/submission_management_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import {
  type PlanTarget,
  isPlanTargetReady,
  toPlanTargetRequest,
} from '~/pages/ProcurementPlanDetail/models/planTarget'

/**
 * SubmissionManagementService.GetPlanCounterpartyMismatch を呼ぶ hook (AC-PSM-063)。
 * 対象は版の ID か業務キー (AC-PPD-028 の版の無い計画) のどちらか (`PlanTarget`)。
 *
 * 取得失敗は詳細画面全体を止めない (解消ボタンを出さないだけ) ため、
 * global QueryClient の `throwOnError: true` を `false` に上書きする。
 * この上書きの欠落は、本番構成 (`queryThrowOnError: true`) を再現した F5 テストで検出する。
 */
export function useGetPlanCounterpartyMismatch(
  target: PlanTarget,
): UseQueryResult<GetPlanCounterpartyMismatchResponse, ConnectError> {
  return useQuery(getPlanCounterpartyMismatch, toPlanTargetRequest(target), {
    enabled: isPlanTargetReady(target),
    throwOnError: false,
  })
}
